import Config from "./Config";
var baseURL = Config.Setting.apiURL;
var baseImageURL = Config.Setting.baseImageURL;
var wcfUrl = Config.Setting.baseUrl;

const UrlConstant = {
  ThumbImageURL: baseImageURL + "/images/",
  LargeImageURL: baseImageURL + "/images/",
  Heartbeat: baseURL + "/Auth/Heartbeat",
  Auth: baseURL + "/Auth",
  Login: baseURL + "/Login",
  SignOut: baseURL + "/Signout",
  AccountStatement: baseURL + "/Statement/",
  EnterpriseOrders: baseURL + "/Order/Enterprise/",
  EnterpriseInvoices: baseURL + "/EnterpriseInvoice/",
  EnterpriseCategories: baseURL + "/Category/",
  EnterpriseCategoryProduct: baseURL + "/Product/",
  EnterpriseCategoryProductOption: baseURL + "/ProductOption/",
  EnterpriseSetting: baseURL + "/EnterpriseSetting/",
  EnterpriseSettingMerchantVerfication: baseURL + "/pos/merchant/verification/",
  EnterpriseSettingMerchantCodeVerfication: baseURL + "/pos/accessToken/",
  EnterpriseOrderSource: baseURL + "/EnterpriseOrderSource",
  EnterpriseAddonGroup: baseURL + "/AddonGroup/",
  EnterpriseTopping: baseURL + "/Topping/",
  EnterpriseMenu: baseURL + "/EnterpriseMenu/",
  EnterpriseProductJson: baseURL + "/EnterpriseProductJson/",
  EnterpriseUsers: baseURL + "/EnterpriseUser/",
  Area: baseURL + "/Area/",
  Tag: baseURL + "/Tag",
  GlobalConfiguration: baseURL + "/GlobalConfiguration/",
  DeliveryArea: baseURL + "/DeliveryArea/",
  City: baseURL + "/City/",
  EnterpriseAddress: baseURL + "/EnterpriseAddress/",
  DeliveryZone: baseURL + "/DeliveryZone/",
  Town: baseURL + "/Town/",
  Permission: baseURL + "/Permission/",
  Enterprise: baseURL + "/Enterprise/",
  EnterpriseAI: baseURL,
  Commission: baseURL + "/Commission/",
  User: baseURL + "/User/",
  Account: baseURL + "/Account/",
  EnterpriseQuickSetting: baseURL + "/EnterpriseSetting/QuickSetting",
  EnterpriseAgent: baseURL + "/EnterpriseAgent/",
  ScheduleEnterpriseQuickSetting:
    baseURL + "/EnterpriseSetting/ScheduleQuickSetting",
  PhotoDictionary: baseURL + "/PhotoDictionary/",
  EnterpriseRating: baseURL + "/Rating/",
  Campaign: baseURL + "/Campaign/",
  EnterpriseVoucher: baseURL + "/Voucher/",
  EnterpriseVoucherBatch: baseURL + "/VoucherBatch/",
  VoucherSearch: baseURL + "/Voucher/Search",
  FoodTypeCuisine: baseURL + "/FoodTypeDictionary/",
  Brand: baseURL + "/ProductOption/",
  Orders: wcfUrl + "/wcf/OrderManagement.svc/",
  sendReports: baseURL + "/Enterprise/SummaryReports",
  Device: baseURL + "/Device",
  Notification: baseURL + "/Notification/",
  MoreImagesUrl: baseURL + "/ProductOption/MoreImages",
  MoreFilesUrl: "", //baseURL + '/ProductOption/MoreImages',
  HTMLeditorUrl: baseURL + "/ProductOption/SaveItemInfoDetail/",
  COUNTRY: baseURL + "/Country",
  ACTIVE_COUNTRIES: baseURL + "/Country/Active",
  UpdateConfig: baseURL + "/Country/UpdateConfiguration",
  GetTheme: baseURL + "/EnterpriseSetting/Theme",
  UpdateTheme: baseURL + "/EnterpriseSetting/UpdateThemeJson",
  UpdateCustomCss: baseURL + "/EnterpriseSetting/UpdateCustomCss",
  UpdateHomeSettings: baseURL + "/EnterpriseSetting/SaveHomeSettings",
  EnterpriseProfileHealth: baseURL + "/EnterpriseSetting/GetProfileHealth/",
  UpdateSliders: baseURL + "/EnterpriseSetting/SaveSliderJson",
  SaveNavigation: baseURL + "/EnterpriseSetting/SaveNavigation",
  AreaPolygon: baseURL + "/AreaPolygon/",
  EnterpriseCMS: baseURL + "/EnterpriseCMS/",
  OrderDetail: baseURL + "/OrderDetail/",
  EnterpriseGroup: baseURL + "/EnterpriseGroup/",
  Department: baseURL + "/Department/",
  SupportType: baseURL + "/SupportType/",
  Complaint: baseURL + "/Complaint/",
  ComplaintStatus: baseURL + "/ComplaintStatus/",
  OrderSupport: baseURL + "/OrderSupport/",
  Concierge: baseURL + "/concierge/",
  Itinerary: baseURL + "/Itinerary/",
  EnterpriseService: baseURL + "/EnterpriseService/",
  ExternalService: baseURL + "/externalservice/",
  OrderRouting: baseURL + "/OrderRouting/",
  Banner: baseURL + "/banner/",
  QRScans: baseURL + "/qrscans/",
  Shifts: baseURL + "/shift/",
};

export default UrlConstant;
